import { render, staticRenderFns } from "./StudentBottomPanel.vue?vue&type=template&id=521ff1ae&scoped=true&lang=pug&"
import script from "./StudentBottomPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentBottomPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentBottomPanel.vue?vue&type=style&index=0&id=521ff1ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ff1ae",
  null
  
)

export default component.exports